import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, CancelSVGpath, CompletedSVGpath, InfoSquareSVGpath, WarningSVGpath, WarningStopSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


const getAlertBackgroundBrightnessDefault = ()=>'default';

var styles = {
    "alert": "Alert-module_alert__zUAdu",
    "iconWrapper": "Alert-module_iconWrapper__BhQFh",
    "content": "Alert-module_content__uZBSj",
    "closeButton": "Alert-module_closeButton__k-eGJ",
    "alert_light": "Alert-module_alert_light__rDAfE",
    "alert_success": "Alert-module_alert_success__feII7",
    "icon": "Alert-module_icon__Q-wN3",
    "alert_neutral": "Alert-module_alert_neutral__iLqaw",
    "alert_warning": "Alert-module_alert_warning__PRnrm",
    "alert_danger": "Alert-module_alert_danger__hJaBz"
};

const Alert = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, backgroundBrightness = getAlertBackgroundBrightnessDefault(), svgPath, variant, ariaLive, showAlert, children, onClose }, ref)=>{
    const variantClassName = styles[`alert_${variant}`];
    const { t } = useTranslation('ds_status', {
        i18n: dsI18n
    });
    let svg;
    if (svgPath) {
        svg = svgPath;
    } else if (variant === 'success') {
        svg = CompletedSVGpath;
    } else if (variant === 'neutral') {
        svg = InfoSquareSVGpath;
    } else if (variant === 'warning') {
        svg = WarningSVGpath;
    } else {
        svg = WarningStopSVGpath;
    }
    const getAriaLive = ()=>{
        if (ariaLive) {
            return ariaLive;
        } else if (variant === 'danger') {
            return 'assertive';
        } else {
            return 'polite';
        }
    };
    const concatenatedClassName = `${styles.alert} ${variantClassName} ${backgroundBrightness === 'light' ? styles.alert_light : ''} ${className}`.trim();
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        id: id,
        lang: lang,
        "data-testid": dataTestId,
        "aria-live": getAriaLive(),
        "aria-atomic": true,
        children: showAlert && children && /*#__PURE__*/ jsxs("div", {
            className: concatenatedClassName,
            children: [
                /*#__PURE__*/ jsx("span", {
                    className: styles.iconWrapper,
                    children: /*#__PURE__*/ jsx(Icon, {
                        size: 'large',
                        svgPath: svg,
                        className: styles.icon
                    })
                }),
                /*#__PURE__*/ jsx("span", {
                    className: styles.content,
                    children: children
                }),
                onClose && /*#__PURE__*/ jsx(IconButton, {
                    className: styles.closeButton,
                    size: 'small',
                    svgPath: CancelSVGpath,
                    title: t('alert.CloseMessage'),
                    onClick: ()=>{
                        onClose?.();
                    }
                })
            ]
        })
    });
});
Alert.displayName = 'Alert';

export { Alert, getAlertBackgroundBrightnessDefault };
